import { useEffect, useMemo } from 'react';

import { InputBase, ListItemText, MenuItem, Select } from '@material-ui/core';

import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

import { SelectListItem, useFeatureFlag } from '@spotify/confidence-core-react';

export function ThemeSwitcher() {
  const appThemeApi = useApi(appThemeApiRef);
  const allThemes = appThemeApi.getInstalledThemes();
  const activeTheme = appThemeApi.getActiveThemeId();

  const { enabled: buiThemeEnabled } = useFeatureFlag<{ enabled: boolean }>(
    'bui-theme',
    { enabled: false },
  );

  useEffect(() => {
    if (buiThemeEnabled && !activeTheme) {
      appThemeApi.setActiveThemeId('mui-bui-dark');
    }
  }, [buiThemeEnabled, activeTheme, appThemeApi]);

  const themeIds = useMemo(() => {
    if (buiThemeEnabled) {
      return allThemes;
    }
    return allThemes.filter(theme => !theme.id.startsWith('mui-bui-'));
  }, [allThemes, buiThemeEnabled]);

  const handleSetTheme = (newThemeId: string | undefined) => {
    if (themeIds.some(it => it.id === newThemeId)) {
      appThemeApi.setActiveThemeId(newThemeId);
    } else {
      appThemeApi.setActiveThemeId(undefined);
    }
  };

  return (
    <SelectListItem>
      <ListItemText primary="Theme" />
      <Select
        value={activeTheme ?? ''}
        onChange={e => handleSetTheme(e.target.value as string)}
        input={<InputBase />}
        aria-label="Select color theme"
      >
        {themeIds.map(theme => (
          <MenuItem key={theme.id} value={theme.id}>
            {theme.title}
          </MenuItem>
        ))}
        <MenuItem value="">Auto</MenuItem>
      </Select>
    </SelectListItem>
  );
}
